export default __webpack_public_path__ + "static/media/Retail3.9ce07613.jpg";